
(function() {
  var result = { translations: { "hu": { "i18n": { "duration": { "seconds": "{{ seconds }} mp.", "minutes": "{{ minutes }} p.", "hours": "{{ hours }} \xF3.", "hoursAndMinutes": "{{ hours }} \xF3. {{ minutes }} p.", "days": "{{ days }} nap", "shortForm": { "seconds": "{{ seconds }} mp", "minutes": "{{ minutes }} p", "hours": "{{ hours }} \xF3", "days": "{{ days }} n", "hoursAndMinutes": "{{ hours }} \xF3 {{ minutes }} p" } }, "dateTime": { "quarterAndYear": "{{yearNumber}}. {{quarterNumber}}. n\xE9." }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, {{extension}} mell\xE9k" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "hu": "static-7.967"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.967",
    "ar-eg": "static-7.967",
    "bg": "static-7.967",
    "bn": "static-7.967",
    "ca-es": "static-7.967",
    "cs": "static-7.967",
    "da": "static-7.967",
    "de": "static-7.967",
    "el": "static-7.967",
    "en-gb": "static-7.967",
    "en": "static-7.967",
    "es-mx": "static-7.967",
    "es": "static-7.967",
    "fi": "static-7.967",
    "fr-ca": "static-7.967",
    "fr": "static-7.967",
    "he-il": "static-7.967",
    "hr": "static-7.967",
    "hu": "static-7.967",
    "id": "static-7.967",
    "it": "static-7.967",
    "ja": "static-7.967",
    "ko": "static-7.967",
    "lt": "static-7.967",
    "ms": "static-7.967",
    "nl": "static-7.967",
    "no": "static-7.967",
    "pl": "static-7.967",
    "pt-br": "static-7.967",
    "pt-pt": "static-7.967",
    "ro": "static-7.967",
    "ru": "static-7.967",
    "sk": "static-7.967",
    "sl": "static-7.967",
    "sv": "static-7.967",
    "th": "static-7.967",
    "tl": "static-7.967",
    "tr": "static-7.967",
    "uk": "static-7.967",
    "vi": "static-7.967",
    "x-pseudo": "static-7.967",
    "zh-cn": "static-7.967",
    "zh-hk": "static-7.967",
    "zh-tw": "static-7.967"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hu', {version: 'static-7.967'}); }
})();


